import { getEnvVar } from '@nucleus/lib-environment';

export const GlobalNamespace = getEnvVar('GLOBAL_NAMESPACE', 'default_namespace');
